import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { TokenService } from './token.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  /**
   * Constructor
   */
  constructor(private _authService: AuthService, private _tokenService: TokenService) {}

  private _oauthHeaderName = `OAuth-ClientId`;
  private _authorizationHeaderName = `Authorization`;

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(req: HttpRequest<void>, next: HttpHandler): Observable<HttpEvent<void>> {
    let cloned = req.clone();

    const accessToken = this._tokenService.accessToken;
    const clientId = this._tokenService.clientId;

    let headers = req.headers.set('Access-Control-Allow-Origin', '*');

    if (clientId) {
      headers = headers.set(this._oauthHeaderName, clientId);
    }

    if (accessToken) {
      headers = headers.set(this._authorizationHeaderName, `Bearer ${accessToken.accessToken}`);
    }

    cloned = req.clone({
      url: `${cloned.url}`,
      headers,
    });

    return next.handle(cloned).pipe(
      catchError((error) => {
        // Catch "401 Unauthorized" responses
        if (error instanceof HttpErrorResponse && error.status === 401) {
          // Sign out
          this._authService.logout();
        }
        return throwError(error);
      }),
    );
  }
}
